
// 数据看板
import fetch from '../fetch';

import {
  // 会员积分
  VIP_BOARD_POINT_DATA,
  VIP_BOARD_POINT_LINE_CHART,
  VIP_BOARD_POINT_PIE_CHART,
  VIP_BOARD_POINT_DETAIL_BY_DATE,
  VIP_BOARD_POINT_DETAIL,
  // 会员等级
  VIP_BOARD_LEVEL_DATA,
  VIP_BOARD_LEVEL_LINE_CHART,
  VIP_BOARD_LEVEL_PIE_CHART,
  VIP_BOARD_LEVEL_DETAIL_BY_DATE,
  VIP_BOARD_LEVEL_DETAIL,
  // 会员留存分析
  VIP_BOARD_RETAIN_LIST,
  // 会员分析
  VIP_BOARD_USER_DATA,
  VIP_BOARD_USER_LINE_CHART,
  VIP_BOARD_USER_DETAIL,
  VIP_BOARD_VIP_ANALYZE_DETAIL,
  // 来源分析
  VIP_BOARD_SOURCE_LINE_CHART,
  VIP_BOARD_SOURCE_PIE_CHART,
  VIP_BOARD_SOURCE_DETAIL,
  VIP_BOARD_SOURCE_DETAIL_LINE_CHART,
  VIP_BOARD_SOURCE_DETAIL_BY_DETAIL,
  // 销售分析
  VIP_BOARD_SALE_DATA,
  VIP_BOARD_SALE_LIST,
  VIP_BOARD_WHOLE_SALE_LIST
} from '../url';

/**
 * 会员积分数据概况
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getpointData(data) {
  return fetch({
    url: VIP_BOARD_POINT_DATA,
    method: 'post',
    data: data
  });
};

/**
 * 会员积分-折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointLineChart(data) {
  return fetch({
    url: VIP_BOARD_POINT_LINE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 会员积分-饼图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointPieChart(data) {
  return fetch({
    url: VIP_BOARD_POINT_PIE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 会员积分-当天明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointDetailByDate(data) {
  return fetch({
    url: VIP_BOARD_POINT_DETAIL_BY_DATE,
    method: 'post',
    data: data
  });
};

/**
 * 会员积分-数据明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointDetail(data) {
  return fetch({
    url: VIP_BOARD_POINT_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 会员等级数据概况
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelData(data) {
  return fetch({
    url: VIP_BOARD_LEVEL_DATA,
    method: 'post',
    data: data
  });
};

/**
 * 会员等级-折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelLineChart(data) {
  return fetch({
    url: VIP_BOARD_LEVEL_LINE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 会员等级-饼图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelPieChart(data) {
  return fetch({
    url: VIP_BOARD_LEVEL_PIE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 会员等级-当天明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelDetailByDate(data) {
  return fetch({
    url: VIP_BOARD_LEVEL_DETAIL_BY_DATE,
    method: 'post',
    data: data
  });
};

/**
 * 会员等级-数据明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelDetail(data) {
  return fetch({
    url: VIP_BOARD_LEVEL_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 会员留存分析
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getRetainList(data) {
  return fetch({
    url: VIP_BOARD_RETAIN_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 会员分析 - 数据概况
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserData(data) {
  return fetch({
    url: VIP_BOARD_USER_DATA,
    method: 'post',
    data: data
  });
};

/**
 * 会员分析 - 详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function vipAnalyzeDetail(data) {
  return fetch({
    url: VIP_BOARD_VIP_ANALYZE_DETAIL,
    method: 'POST',
    data: data
  });
};

/**
 * 会员等级-数据明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserLineChart(data) {
  return fetch({
    url: VIP_BOARD_USER_LINE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 会员留存分析
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserDetail(data) {
  return fetch({
    url: VIP_BOARD_USER_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 来源分析-折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSourceLineChart(data) {
  return fetch({
    url: VIP_BOARD_SOURCE_LINE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 来源分析-饼图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSourcePieChart(data) {
  return fetch({
    url: VIP_BOARD_SOURCE_PIE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 来源分析-数据明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSourceDetail(data) {
  return fetch({
    url: VIP_BOARD_SOURCE_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 来源分析-明细-折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSourceDetailLineChart(data) {
  return fetch({
    url: VIP_BOARD_SOURCE_DETAIL_LINE_CHART,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

/**
 * 来源分析-明细-数据明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSourceDetailByDetail(data) {
  return fetch({
    url: VIP_BOARD_SOURCE_DETAIL_BY_DETAIL,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

/**
 * 销售分析-数据概况
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSaleData(data) {
  return fetch({
    url: VIP_BOARD_SALE_DATA,
    method: 'post',
    data: data
  });
};

/**
 * 销售分析-列表数据-折线图数据
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSaleList(data) {
  return fetch({
    url: VIP_BOARD_SALE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 销售分析-整体列表数据-折线图数据
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getWholeSaleList(data, type) {
  let url = VIP_BOARD_WHOLE_SALE_LIST;
  if (type === 2) {
    url = VIP_BOARD_SALE_LIST;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

const dataKanban = {
  getpointData,
  getPointLineChart,
  getPointPieChart,
  getPointDetailByDate,
  getPointDetail,
  // 会员等级
  getLevelData,
  getLevelLineChart,
  getLevelPieChart,
  getLevelDetailByDate,
  getLevelDetail,
  // 会员留存分析
  getRetainList,
  // 会员分析
  getUserData,
  getUserLineChart,
  getUserDetail,
  vipAnalyzeDetail,
  // 来源分析
  getSourceLineChart,
  getSourcePieChart,
  getSourceDetail,
  getSourceDetailLineChart,
  getSourceDetailByDetail,
  // 销售分析
  getSaleData,
  getSaleList,
  getWholeSaleList
};

export { dataKanban };
